import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { FieldglassReferenceDataProvider } from '../shared/context/FieldglassReferenceDataProvider'
import { FieldglassIssueActionsProvider } from '../shared/context/FieldglassIssueActionsProvider'
import { FieldglassJobPostingProvider } from './context/FieldglassJobPostingProvider'
import { FieldglassJobPostingMain } from './components/FieldglassJobPostingMain'

export const FieldglassJobPosting = () => {
  return (
    <NuqsAdapter>
      <FieldglassReferenceDataProvider>
        <FieldglassIssueActionsProvider>
          <FieldglassJobPostingProvider>
            <FieldglassJobPostingMain />
          </FieldglassJobPostingProvider>
        </FieldglassIssueActionsProvider>
      </FieldglassReferenceDataProvider>
    </NuqsAdapter>
  )
}
